import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
	routes: [{
		path: "/",
		name: "Code",
		component: () => import("@/views/code.vue")
	}, {
		path: "/auth_token",
		name: "AuthToken",
		component: () => import("@/views/auth_token.vue"),
	}, {
		path: "/recived_result",
		name: "recivedResult",
		component: () => import("@/views/result.vue"),
	}]
})